var map = {
	"./en.json": "e312",
	"./en/Common.json": "0a2d",
	"./en/Core/Footer.json": "173d",
	"./en/Core/Toolbar.json": "f26b",
	"./en/Home.json": "5cc6",
	"./es.json": "ef52"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4999";